import i18n from '@/plugins/i18n';
import { RouteNames } from '@/data/routes';

interface MenuItem {
  title: () => string;
  route: string;
  matchForChildren?: boolean;
  faIcon?: string;
}

interface MenuSection {
  title: () => string;
  route: string;
  subtitle?: () => string;
  forceClickable?: boolean;
  forceDropdown?: boolean;
  children?: MenuItem[];
}

export const WAYFINDING_ROUTES = [
  RouteNames.MCA.SPEND,
  RouteNames.MCA.ADVANCES,
  RouteNames.MCA.CLEARCO_CARD,
  RouteNames.PAY_VENDORS.INDEX,
  RouteNames.MCA.VENDOR_LIST,
  RouteNames.HOME.INITIAL,
  RouteNames.PAYMENTS.UPCOMING,
  RouteNames.PROFILE.INDEX,
  RouteNames.ACCOUNT.SETTINGS,
  RouteNames.DATA_SECURITY.INDEX,
  RouteNames.AUTH.LOGOUT,
  RouteNames.CONNECTED_ACCOUNTS.INDEX,
  RouteNames.DOCUMENTS.INDEX,
  RouteNames.TEAM.INDEX,
];

export enum WAYFINDING_MENU_KEYS {
  FINANCING = 'financing',
  ACCOUNT = 'account',
  CARD = 'card',
  VENDORS = 'vendors',
  PAYMENTS = 'payments',
  BANKING = 'banking',
  HOME = 'home',
  REVENUE_SOURCES = 'revenueSources',
  ALL_DOCUMENTS = 'allDocuments',
  TEAM = 'team',
  UPCOMING_PAYMENTS = 'upcomingPayments',
  BUSINESS_PROFILE = 'businessProfile',
}

export const WAYFINDING_MENU_TEMPLATE: Partial<
  Record<WAYFINDING_MENU_KEYS, MenuSection>
> = {
  [WAYFINDING_MENU_KEYS.ACCOUNT]: {
    title: () => i18n.t('data.wayfinding.wayfindingMenuTemplate.myAccount'),
    route: '',
    children: [
      {
        title: () =>
          i18n.t('data.wayfinding.wayfindingMenuTemplate.accountSettings'),
        route: RouteNames.ACCOUNT.SETTINGS,
      },
      {
        title: () => i18n.t('data.wayfinding.wayfindingMenuTemplate.team'),
        route: RouteNames.TEAM.INDEX,
      },
      {
        title: () =>
          i18n.t('data.wayfinding.wayfindingMenuTemplate.dataPrivacy'),
        route: RouteNames.DATA_SECURITY.INDEX,
      },
      {
        title: () => i18n.t('data.wayfinding.wayfindingMenuTemplate.signOut'),
        route: RouteNames.AUTH.LOGOUT,
      },
    ],
  },
  [WAYFINDING_MENU_KEYS.HOME]: {
    title: () => i18n.t('data.wayfinding.wayfindingMenuTemplate.home'),
    route: RouteNames.HOME.INDEX,
  },
  [WAYFINDING_MENU_KEYS.BANKING]: {
    title: () => i18n.t('data.wayfinding.wayfindingMenuTemplate.banking'),
    subtitle: () => i18n.t('data.wayfinding.wayfindingMenuTemplate.newProduct'),
    route: RouteNames.BANKING.INDEX,
  },
  [WAYFINDING_MENU_KEYS.PAYMENTS]: {
    title: () => i18n.t('data.wayfinding.wayfindingMenuTemplate.funding'),
    route: RouteNames.HOME.INITIAL,
    forceClickable: true,
    children: [],
  },
  [WAYFINDING_MENU_KEYS.UPCOMING_PAYMENTS]: {
    title: () =>
      i18n.t('data.wayfinding.wayfindingMenuTemplate.repaymentSchedule'),
    route: RouteNames.PAYMENTS.UPCOMING,
    forceClickable: true,
    children: [],
  },
  [WAYFINDING_MENU_KEYS.BUSINESS_PROFILE]: {
    title: () =>
      i18n.t('data.wayfinding.wayfindingMenuTemplate.businessProfile'),
    route: RouteNames.PROFILE.INDEX,
    forceClickable: true,
    children: [],
  },
  [WAYFINDING_MENU_KEYS.REVENUE_SOURCES]: {
    title: () => 'Revenue Sources',
    route: RouteNames.CONNECTED_ACCOUNTS.INDEX,
    forceClickable: true,
    children: [],
  },
  [WAYFINDING_MENU_KEYS.ALL_DOCUMENTS]: {
    title: () => 'Documents',
    route: RouteNames.DOCUMENTS.INDEX,
    forceClickable: true,
    children: [],
  },
  [WAYFINDING_MENU_KEYS.FINANCING]: {
    title: () => i18n.t('data.wayfinding.wayfindingMenuTemplate.financing'),
    route: RouteNames.MCA.SPEND,
    forceDropdown: true,
    children: [],
  },
};
